// eslint-disable-next-line import/prefer-default-export
export const userInfoKeys = {
  base: ['userInfo'] as const,
};
